export type Callback = (message: Event) => void;
export const shellListener = (callback: Callback): (() => void) => {
  const shellElement = document.getElementById("shell");
  if (shellElement) {
    shellElement.shadowRoot?.addEventListener(
      "click",
      (event) => callback(event),
      true
    );
    // shellElement.shadowRoot?.addEventListener(
    //   "pointerenter",
    //   (event) => callback(event),
    //   true
    // );
    // shellElement.shadowRoot?.addEventListener(
    //   "focusin",
    //   (event) => callback(event),
    //   true
    // );
    return () => {
      shellElement.removeEventListener("click", (event) => callback(event));
      // shellElement.removeEventListener("pointerenter", (event) =>
      //   callback(event)
      // );
      // shellElement.removeEventListener("focusin", (event) => callback(event));
    };
  }
  console.error("ShellListener: No shell element found.");
  return () => {
    console.log("No listener active");
  };
};
